import React, { useState, useEffect } from 'react'
import { Box, Typography, Button, ListItem, Chip, CardContent, Grid, Card, IconButton, CircularProgress, List, Paper, useTheme, Backdrop } from '@material-ui/core'
import { baseApiUrl } from '../dataProvider/sails';
import Checkbox from '../checkbox'
import { makeStyles } from '@material-ui/core/styles'
import SelectBox from '../CustomizedUIs/CustomSelectBox'
import colors from '../CustomizedUIs/Colors'
import CustomPoper from '../CustomizedUIs/CustomPoper'
import DialogChooseFile from '../file-management/file-management-dialog'
import { useDataProvider, useTranslate, usePermissions, Loading } from 'react-admin'
import categories from '../categories'
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom'
import TextField from '../CustomizedUIs/CustomTextFiled'
import { isAudio, isImage, isVideo, isMedia } from '../utils';
import { red, pink } from '@material-ui/core/colors';
import ic_attachment from '../assets/icons/ic_attachment.png'
import ic_delete from '../assets/icons/primary-blue-bin.png'
import ic_computer from '../assets/icons/computer.png'
import ic_folder from '../assets/icons/folder-empty.png'
import CustomPopover from '../CustomizedUIs/CustomPopoverArrow'
import axios from 'axios'
import {
    usePopupState,
    bindToggle
} from 'material-ui-popup-state/hooks'
import CreateInSelect from '../CustomizedUIs/CreateInSelect';
import TextButton from '../CustomizedUIs/TextButton';


const bgColorError = pink['50'];
const textColorError = red['700'];

const useStyles = makeStyles(theme => ({

    borderImage: {
        borderRadius: '10px',
        backgroundColor: '#c1e5fa',
        '&:hover': {
            backgroundColor: '#a7cce7',
        }
    }
    , borderUpImange: {
        width: '500px',
        height: ' 145px',
        borderRadius: ' 10px',
        boxShadow: '0 5px 15px 0 rgba(0, 0, 0, 0.05)',
        backgroundColor: ' #ffffff',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    input: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: '100%',
        cursor: 'pointer',
        opacity: 0,
    },
    TitleImage: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    TextValue: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.385,
        letterSpacing: '0.13px',
        color: '#88898c',
    },

    large: {
        marginLeft: 16,
        border: '1px solid #ddd',
        background: 'white',
        borderRadius: 4,
        padding: 5,
        width: 150,
        height: 100,
        '&:hover': {
            boxShadow: '0 0 2px 1px rgba(0, 140, 186, 0.5)'
        }
    },
    title: {
        fontFamily: 'UniviaPro-Medium',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 500,
        lineHeight: '21.6px',
        letterSpacing: 'normal',
        color: '#4f5064',
        fontSize: '11px',
    },
}));

export function CircularProgressWithLabel(props) {
    return (
        <Box position="relative" display="inline-flex">
            <CircularProgress variant="static" size={80} {...props} />
            <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Typography variant="body1" component="div" style={{ color: 'white' }}>{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}



const FormUpdate = ({ id, loading, setLoading, }) => {
    const classes = useStyles()
    const dataProvider = useDataProvider()
    const { permissions, loaded } = usePermissions();
    const history = useHistory()
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openPoper, setOpenPopper] = React.useState(false);
    const [openType, setOpenType] = useState(false)
    const [types, setTypes] = useState()
    const [typeValue, setTypeValue] = useState('')
    const [fileType, setFileType] = useState('From file')
    const [openFileType, setOpenFileType] = useState(false)
    const [openCategory, setOpenCategory] = useState(false)
    const [messageError, setMessageError] = useState('')
    const [file, setFile] = useState()
    const translate = useTranslate()
    const filePopupState = usePopupState({ variant: 'popper', popupId: 'pickFile' });
    const logoPopupState = usePopupState({ variant: 'popper', popupId: 'pickLogo' });
    const [saveLoading, setSaveLoading] = useState(false)
    const [progress, setProgress] = useState(0)
    const [models, setModels] = useState([])
    const [openCreate, setOpenCreate] = useState(false)
    const theme = useTheme()
    const [value, setValue] = useState({
        profile: '',
        model: '',
        version: '',

    })
    const [open, setOpen] = useState({
        profile: false,
        model: false,
        version: false,
    })
    const [profiles, setProfiles] = useState([])
    const [newModel, setNewModel] = useState('')
    const [error, setError] = useState({
        profile: { status: id ? false : true, message: '' },
        model: { status: id ? false : true, message: '' },
        version: { status: id ? false : true, message: '' },
    })

    const [url, setUrl] = useState('')
    const [logo, setLogo] = useState()
    const [openFile, setOpenFile] = useState({
        status: false,
        defaultId: 1,
        format: '',
        setResponse: null
    })
    const [categories, setCategories] = useState([])
    const [isError, setIsError] = useState(id ? false : true)


    const getListModel = () => {
        //setLoading(true);
        dataProvider('GET_LIST', 'device-tvmodel', {
            filter: {},
            // pagination: { page: 1, perPage: 100 },
            pagination: {},
            sort: {
                field: 'name',
                order: 'DESC'
            },
        }).then(({ data }) => {
            setModels(data)
        }).catch({})
    }

    const getListDeviceProfiles = () => {
        //setLoading(true);
        dataProvider('GET_LIST', 'device-profile', {
            filter: {},
            // pagination: { page: 1, perPage: 100 },
            pagination: {},
            sort: {
                field: 'name',
                order: 'DESC'
            },
        }).then(({ data }) => {
            setProfiles(data)
        }).catch({})
    }


    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const onChangTextValue = (prop) => (e) => {
        setValue({
            ...value, [prop]: e.target.value
        })
        if (e.target.value === '')
            setError({ ...error, [prop]: { status: true, message: 'required' } })
        else
            setError({ ...error, [prop]: { status: false, message: '' } })

    }


    const fileBrowserOnChange = event => {
        var files = [...event.target.files]
        var file = files[0]
        const newFile = {
            name: file.name,
            size: file.size,
            file: file,
            error: false,
            loading: false,
            override: false,
            type: file.type
        };
        setFile(newFile)
    }


    const onCreate = () => {
        setSaveLoading(true)
        setProgress(0)
        const config = {
            onUploadProgress: function (progressEvent) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                setProgress(percentCompleted)
            },
            headers: { token: localStorage.getItem('token') }
        }
        //setLoading(true)
        let data = new FormData()
        let body = {
            profile: value.profile.id,
            version: value.version,
            model: value.model.id,
        }
        data.append('data', JSON.stringify(body))
        data.append('file', file.file)
        axios
            .post(`${baseApiUrl}/firmware`, data, config)
            .then(response => {
                setTimeout(() => {
                    setSaveLoading(false)
                    history.push({
                        pathname: '/DeviceFirmware',
                        state: { open: true, name: value.version, message: translate(`pos.categories.editFolder.success`) }
                    });
                }, 3000)
            })
            .catch(error => {
                setSaveLoading(false)
            })
    }

    const getFirmware = () => {

        dataProvider('GET_ONE', "firmware", {
            id: id
        }).then(({ data }) => {
            setValue({
                profile: data.firmware,
                model: data.model,
                version: data.version,
            })
            setFile(data.file)

        })
    }

    const onEdit = () => {
        setSaveLoading(true)
        setProgress(0)
        const config = {
            onUploadProgress: function (progressEvent) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                setProgress(percentCompleted)
            },
            headers: { token: localStorage.getItem('token') }
        }
        //setLoading(true)
        let data = new FormData()
        let body = {
            profile: value.profile.id,
            version: value.version,
            model: value.model.id,
        }
        if (file.id) {
            body.file = file.id
            data.append('data', JSON.stringify(body))
        }
        else {
            data.append('data', JSON.stringify(body))
            data.append('file', file.file)
        }
        axios
            .put(`${baseApiUrl}/firmware/${id}`, data, config)
            .then(response => {
                setTimeout(() => {
                    setSaveLoading(false)
                    history.push({
                        pathname: '/DeviceFirmware',
                        state: { open: true, name: value.version, message: translate(`pos.categories.editFolder.success`) }
                    });
                }, 3000)
            })
            .catch(error => {
                setSaveLoading(false)
            })
    }

    const createModel = (value) => {
        dataProvider('CREATE', `device-tvmodel`, {
            data: {
                name: value
            }
        }).then(({ data }) => {
            var temps = [...models]
            temps.unshift({
                name: value
            })
            setModels(temps)
            setNewModel('')
            setOpenCreate(false)
        }).catch(error => {
            console.error('Create:', error);
            setNewModel('')
            setOpenCreate(false)
        });
    }

    const pickvalue = (name, pickValue) => {
        if (pickValue !== value[name]) {
            setValue({ ...value, [name]: pickValue })
        }
        if (pickValue === '')
            setError({ ...error, [name]: { status: true, message: 'required' } })
        else
            setError({ ...error, [name]: { status: false, message: '' } })
        setOpen({ ...open, [name]: false })
    }

    const onClickBox = (name) => {
        setOpen({ ...open, [name]: !open[name] })
    }


    useEffect(() => {

        getListDeviceProfiles()
        getListModel()
        id && getFirmware()


    }, [])


    if (loading) return <Loading />

    return (
        <Box>
            <Backdrop style={{ zIndex: 1000 }} open={saveLoading} >
                <CircularProgressWithLabel value={progress} />
            </Backdrop>
            {
                messageError != "" && (
                    <Box borderRadius='6px' my={1} width={500} bgcolor={bgColorError} py={1}>
                        <Typography variant='subtitle2' style={{ color: textColorError, margin: '1em' }}>{messageError}</Typography>
                    </Box>
                )
            }

            <Box my={2}>
                <SelectBox
                    label={'Device platform'}
                    value={<Typography className={classes.TextValue}>{value.profile.name || 'None'}</Typography>}
                    open={open.profile}
                    handleClick={() => onClickBox('profile')}
                    required={true}
                >
                    <ListItem className={classes.boxBoder} style={{ padding: '8px' }} button onClick={() => pickvalue('profile', '')}>
                        <Typography className={classes.TextValue}>(None)</Typography>
                    </ListItem>
                    {
                        profiles.map(item => (
                            <ListItem key={'profile' + item.id} className={classes.boxBoder} style={{ padding: '8px' }} button onClick={() => pickvalue('profile', item)}>
                                <Typography className={classes.TextValue}>{item.name}</Typography>
                            </ListItem>
                        ))
                    }
                </SelectBox>
            </Box>

            <Box my={2}>
                <SelectBox
                    label={'Device model'}
                    value={<Typography className={classes.TextValue}>{value.model.name || 'None'}</Typography>}
                    open={open.model}
                    handleClick={() => onClickBox('model')}
                    required={true}
                    CreateBox={
                        <CreateInSelect
                            name={'model'}
                            valueInput={newModel}
                            onChangValueInput={(e) => { setNewModel(e.target.value) }}
                            handelCreateNew={createModel}
                            openCreate={openCreate}
                            handelCancelCreate={() => setOpenCreate(false)}
                            clickOpenCreate={() => setOpenCreate(!openCreate)}
                        />}
                >
                    <ListItem className={classes.boxBoder} style={{ padding: '8px' }} button onClick={() => pickvalue('model', '')}>
                        <Typography className={classes.TextValue}>(None)</Typography>
                    </ListItem>
                    {
                        models.map(item => (
                            <ListItem key={'profile' + item.id} className={classes.boxBoder} style={{ padding: '8px' }} button onClick={() => pickvalue('model', item)}>
                                <Typography className={classes.TextValue}>{item.name}</Typography>
                            </ListItem>
                        ))
                    }
                </SelectBox>
            </Box>
            <Box my={2}>
                <TextField
                    required
                    style={{ width: 500 }}
                    label={'Firmware version'}
                    // onBlur={() => { validate('name', textValue.name) }}
                    value={value.version}
                    onChange={onChangTextValue('version')}
                    error={error.version.message !== '' && error.version.status}
                    helperText={error.version.message}
                    endDom={<CustomPoper
                        open={openPoper}
                        anchorEl={anchorEl}
                        handleClick={handleClickOpenPoper}
                        handleClose={handleClosePoper}
                        title={'Version'}
                        content={'This is firmware version'}
                        icon={<b>?</b>}
                    />} />
            </Box>

            <Box display='flex'
                justifyItems='center'
                pt={1} pb={2} my={1}
                bgcolor={colors.white['50']}
                border={1}
                borderColor={colors.lightBlue['200']}
                borderRadius='4px' >
                <Box width={469} m='auto'>
                    <Typography className={classes.title} style={{ marginBottom: 8 }}>Firmware URL/file
                    <sup style={{ fontSize: 'smaller', position: 'absolute', marginLeft: 2 }}>*</sup>
                    </Typography>
                    <Box display='flex' py={1} px={2} bgcolor='white' border={1} borderColor='#c1e5fa' borderRadius={4}>
                        <Box display='flex' flexGrow={1} alignItems='center'>
                            <img src={ic_attachment} width={27} height={27} style={{ marginRight: 8 }}></img>
                            <Typography className={classes.title}>{translate(`pos.media.file`)}</Typography>
                        </Box>
                        <Button variant='contained' color='primary'>
                            {
                                file ? translate(`pos.channels.change`) : translate(`pos.channels.browse`)
                            }
                            <input type='file' accept=".bem,.msd" onChange={fileBrowserOnChange} className={classes.input} />
                        </Button>

                        {/* <DialogChooseFile
                                            withoutPermission={true}
                                            defaultId={openFile.defaultId}
                                            open={openFile.status}setSoundValue'
                                            pickerMode='pickMediaOnly'
                                            handleClose={handleCloseFileDialog}
                                            setChooseValue={openFile.setResponse}
                                        /> */}

                    </Box>
                    {
                        file && (
                            <Box display='flex' py={2} boxShadow='0 3px 6px 0 rgba(27, 102, 157, 0.04)' px={2} my={1} bgcolor='white'>
                                <Box display='flex' flexGrow={1} alignItems='center'>
                                    <Typography style={{ overflow: 'hidden', textOverflow: 'ellipsis', width: 250 }}>{file.name}</Typography>
                                </Box>
                                <Box display='flex'>
                                    <Typography>
                                        {
                                            file.size / 1024 < 1000 ? (file.size / 1000).toFixed(0) + ' Kb' :
                                                file.size / 1024 / 1024 < 1000 ? (file.size / 1024 / 1024).toFixed(2) + ' Mb' :
                                                    (file.size / 1024 / 1024 / 1024).toFixed(2) + ' Gb'
                                        }
                                    </Typography>
                                    <IconButton
                                        onClick={() => { setFile(null) }}
                                        style={{ marginLeft: 34, padding: 0, width: 25, height: 25, borderRadius: 10, border: 'solid 2px #e5f1f8', backgroundColor: 'white' }}>
                                        <img src={ic_delete} width={12.2} height={12.2} ></img>
                                    </IconButton>

                                </Box>

                            </Box>
                        )
                    }


                </Box>
            </Box>



            <Box my={2} display='flex' width='100%' justifyContent='flex-end' alignItems='flex-end'>
                <TextButton style={{ marginRight: '30px' }} component={Link} to={{ pathname: "/DeviceFirmware" }} />
                <Button disabled={error.version.status || error.model.status || error.profile.status || !file} style={{ pading: 8 }} variant='contained' color='primary' onClick={id ? onEdit : onCreate}>
                    {loading ? (
                        <CircularProgress
                            size={15}
                            thickness={2}
                            color='inherit'
                        />
                    ) :
                        id ? translate(`pos.common.save`) : translate(`pos.common.create`)
                    }
                    {/* {id ? translate(`pos.common.save`) : translate(`pos.common.create`)} */}
                </Button>
            </Box>
        </Box >
    )


}
export default FormUpdate